<template>
  <Layout>
    <div slot="content" class="row">
      <div class="col-md-5 col-xl-3">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-center justify-between">
              <h3>{{ this.custInfo.custName }} ({{ this.custInfo.custAbbr }})</h3>
            </div>
            <div>
              <ItemView class="mt-5" :items="[
                {
                  'OFAC Check 여부': `${this.custInfo.ofacCheckNm || ''}`,
                  '조직영문명': `${this.custInfo.custFullName || ''}`,
                  '사업자등록번호': `${this.custInfo.registno ? this.custInfo.registno.f('registno') : ''}`,
                  '연락처': `${this.custInfo.tel ? this.custInfo.tel.f('tel') : ''}`,
                  'FAX': `${this.custInfo.fax ? this.custInfo.fax.f('tel') : ''}`,
                  'GCIF': `${this.custInfo.gcifNo || ''}`,
                  'CCIF': `${this.custInfo.ccifNo || ''}`,
                  '총괄관리자': { slot: 'managerSlot' },
                  '발신자명': `${this.custInfo.defSenderNm || ''}`,
                  '조직로고': { slot: 'logoSlot' },
                },
              ]">
              <template slot="logoSlot">
                  <div v-if="this.custInfo.logoFileUrl" class="single-rp">
                    <img :src="$url(`${this.custInfo.logoFileUrl}`)" allowfullscreen class="cust-logo" style="max-height:64px;" onerror="this.style.display='none'" />
                  </div>
                </template>
                <template slot="managerSlot">
                  <div class="gray-txt me-3 mb-3"><!-- mng-contain -->
                    <span v-if="managerInfo && managerInfo.memberId" class="pb-3 ps-3 me-2">
                      {{ managerInfo.userNm }} ({{ managerInfo.userIdText }})
                    </span>
                    <div class="mt-2 mb-2 d-inline-flex">
                      <b-dropdown variant="light-primary" size="sm" class="table-action">
                        <template #button-content><b-icon icon="person-circle" font-scale="1.5"></b-icon></template>
                        <b-dropdown-item @click.stop="$bvModal.show('addAdmin');">{{ $t('신규 생성') }}</b-dropdown-item>
                        <b-dropdown-item @click.stop="$bvModal.show('userSelect'); searchManagerKeyword = ''; getManagerList(true);">{{ $t('기존 사용자 선택') }}</b-dropdown-item>
                      </b-dropdown>
                      <b-dropdown v-if="managerInfo && managerInfo.memberId" variant="light-danger" size="sm" class="table-action ms-2">
                        <template #button-content><b-icon icon="person-x-fill" font-scale="1.5"></b-icon></template>
                        <b-dropdown-item @click.stop="unassignManager(managerInfo.userId)">{{ $t('배정해제') }}</b-dropdown-item>
                        <b-dropdown-item @click.stop="deleteManager(managerInfo.memberId)">{{ $t('영구삭제') }}</b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>
                </template>
              </ItemView>
              <div class="text-end mt-6">
                <b-button variant="primary" size="sm" v-b-modal.수정 @click="getCustInfo()">
                  <b-icon icon="pencil" /> {{ $t('수정') }}
                </b-button>
                <b-button variant="danger" size="sm" class="ms-2" @click="deleteCust()">
                  <b-icon icon="trash" /> {{ $t('삭제') }}
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-7 col-xl-9">
        <div class="card">
          <div class="card-body">
            <b-tabs content-class="mt-3">
              <!-- tab-멤버 -->
              <b-tab :title="$t('멤버')" active>
                <TableView :keep-page="keepPage" @action="action" @nextList="getMemberList()" :columns="memberListColumns" :list="memberList"
                  :server-total="memberTotal" minWidth="900px">
                  <div class="d-flex align-items-center position-relative me-3" style="margin-top: -24px;">
                    <b-icon icon="search" />
                    <input :value="searchMemberKeyword" @keyup.enter.stop
                      @change="searchMemberKeyword = $event.target.value; getMemberList(true)" 
                      class="form-control form-control-solid w-250px ps-11" :placeholder="$t('사용자명, 아이디, 이메일')" :title="$t('사용자명, 아이디, 이메일')">
                  </div>
                </TableView>
              </b-tab>            
              <!-- tab-회사도장 -->
              <b-tab :title="$t('회사도장')">
                <TableView @action="stampAction" :columns="custStampColumns" :list="stampList"
                  :server-total="total" minWidth="700px" class="custListStamp">
                </TableView>
              </b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>

    <!-- 총괄 관리자 추가(신규생성) Modal -->
    <ModalForm @action="addAdmAction" id="addAdmin" :title="$t('총괄관리자 추가')" centered :spec="columns" no-close-on-ok
      @show="showAddModal()" ref="adduser">
      <b-form-group :label="$t('아이디')" label-class="required" label-align="end" label-cols="5">
        <b-input-group>
          <b-form-input v-model="userIdInput" />
        </b-input-group>
      </b-form-group>
      <b-form-group :label="$t('비밀번호')" label-align="end" label-cols="5" class="me-3">
        <b-form-input style="color:green" readonly="readonly" :value="'※ ' + $t('자동생성')" />
      </b-form-group>
    </ModalForm>
    <!-- 총괄관리자 - 기존사용자 선택 모달 리스트-->
    <ModalForm id="userSelect" size="lg" title="사용자 선택" centered noCloseOnOk @keyup.enter.stop>
      <TableView @action="selectAdmAction" :actions="actions" @nextList="getManagerList" :columns="userSelColumns"
        :list="managerList" :server-total="managerTotal" minWidth="600px" style="padding: 0 !important;">
        <div class="d-flex align-items-center position-relative me-3">
          <b-icon icon="search" />
          <input :value="searchManagerKeyword" @keyup.enter.stop
            @change="searchManagerKeyword = $event.target.value; getManagerList(true)" 
            class="form-control form-control-solid w-250px ps-11" :placeholder="$t('사용자명, 아이디, 이메일')" :title="$t('사용자명, 아이디, 이메일')" >
        </div>
      </TableView>
    </ModalForm>
    <!-- 조직보기 -->
    <ModalForm id="view" :title="$t('멤버')" :data="selMember" :spec="memberColumns" />
    <!-- 조직 수정 -->
    <ModalForm @action="editAction" id="수정" ok-title="수정" :title="$t('조직 수정')" :data="custInfo" :spec="custColumns">
      <b-form-group label="OFAC Check" label-cols='5'>
        <div class="form-check form-switch form-check-custom form-check-solid">
          <b-form-checkbox switch v-model="custInfo.ofacCheckYn" value="Y" unchecked-value="N" />
        </div>
      </b-form-group>
    </ModalForm>
    <!-- 상세검색 -->
    <b-modal id="상세" modal-class="compact" :ok-title="$t('검색')" :cancel-title="$t('초기화')" centered>
      <div class="modal-form ">
        <b-form-group :label="$t('발효일')" label-align="end" label-cols="5">
          <b-input-group>
            <b-form-input type="date" />
            <span style="padding: 9px 5px 0">~</span>
            <b-form-input type="date" />
          </b-input-group>
        </b-form-group>
        <b-form-group :label="$t('로그인 실패 횟수')" label-align="end" label-cols="5">
          <b-input-group :append="$t('회 이상')"><b-form-input value="0" type="number" /></b-input-group>
        </b-form-group>
      </div>
    </b-modal>

    <!-- 개인도장, 회사도장 -->
    <b-modal lazy modal-class="compact text-center" centered hide-footer id="stamp" size="sm"><img style="max-width:100%" :src="showStamp"></b-modal>
  </Layout>
</template>

<script>
import draggable from 'vuedraggable';
import Layout from "@/components/layout/Layout.vue";
import TableView from "@/components/TableView.vue";
import ModalForm from "@/components/ModalForm.vue";
import ItemView from "@/components/ItemView.vue";
const required = true;

export default {
  components: { draggable, Layout, TableView, ModalForm, ItemView },
  data: () => ({
    selMember: {},
    list: [], keepPage: false, memberList: [], managerList: [], stampList: [], tmpl: [],
    showStamp: null,
    total: 0, memberTotal: 0, managerTotal: 0, 
    searchManagerKeyword: '', searchMemberKeyword: '',
    checked: false,
    authSelect: '',
    userIdInput: '',
    selOptions: [
      { value: '총괄관리자', text: '총괄관리자' },
      { value: '아이디관리자', text: '아이디관리자' },
      { value: '시스템관리자', text: '시스템관리자' },
      { value: 'Super Admin', text: 'Super Admin' },
      { value: '감사', text: '감사' },
    ],
    custInfo: {}, // 조직정보
    managerInfo: {}, // 총괄관리자 정보
    memberListColumns: [   /* 멤버 리스트 출력 */
      { key: 'statusCd', label: '상태', renderer: item => `<b class="badge fs-7 badge-light-${item.statusClass}">${item.statusNm}</b>`, style: { textAlign: 'center' } },
      { label: '사용자', renderer: item => `${item.userNm} (${item.userIdText})`, style: { textAlign: 'center' } },
      { key: 'grpNm', label: '그룹', style: { textAlign: 'center', minWidth: '90px' } },
      { key: 'roleNms', label: '권한명', style: { textAlign: 'center', minWidth: '90px' } },
      { key: 'userNmEn', label: '사용자영문명', form: 4, required, style: { textAlign: 'center' } },
      { readonly: ['수정'], key: 'email', type: 'email', label: '이메일', form: 3, required, style: { textAlign: 'center', maxWidth: '150px' } },
      { key: 'phone', label: '연락처', form: 4, type: 'tel', style: { textAlign: 'center' } },
      { key: 'effectDt', label: '발효일', form: 5, required, type: 'date', style: { textAlign: 'center', minWidth: '95px' }, sendMaper: v => v.replace(/-/g, '') },
      { key: 'memberProdList', label: 'Product/수행업무', style: { textAlign: 'center', minWidth: '180px', maxWidth: '200px' }, renderer: (r) => {
          return (`
            ${r.memberProdList.map(p => `<span class="badge badge-secondary normal" data-u="viewProdTask">${p.prodTaskNm}</span>`).join('')}
          `);
        }
      },
      { key: 'stampTypeNm', label: '도장/서명', style: { textAlign: 'center', minWidth: '120px', maxWidth: '200px' }, renderer: (r) => {
          return (`
            ${r.memberStampList.map(s => `<a class="badge badge-secondary normal" data-u="viewMemberStamp" data-url="${s.stampFileUrl}">[${s.stampTypeNm}]${s.stampNm}</a>`).join('')}
          `);
        }
      },
      { label: '회사도장', style: { textAlign: 'center', minWidth: '120px', maxWidth: '200px' }, renderer: (r) => {
          return (`
            ${r.stampAssignList.map(p => `<a class="badge badge-secondary normal" data-u="viewCustStamp" data-url="${p.stampFileUrl}">${p.stampType != '0' ? `[${p.stampTypeNm}]` : ''}${p.stampNm}</a>`).join('')}
          `);
        }
      },
      { label: '인증서', style: { textAlign: 'left', minWidth: '180px', maxWidth: '200px' }, renderer: (r, s) => {
          if(r.memberCertiList && r.memberCertiList.length > 0) {            
            return `
              <div class="d-flex flex-column justify-content-center">
                ${r.memberCertiList.map(certi => {
                  return `
                    <div class="d-flex align-items-center mb-3">
                      <div class="text-${certi.certiStatusTextClass} normal ps-12">[${certi.certiTypeNm}] ${certi.idn}</div>
                    </div>
                  `;
                }).join('')
                }
              </div>
            `;
          }
        }
      },
      { hide: ['td'], readonly: ['수정'], key: 'userNm', label: '사용자명', form: 0.9, required },
      { hide: ['td'], key: 'userNmEn', label: '사용자영문명', form: 2, required },
    ],
    memberColumns: [   /* 멤버 리스트 모달 */
      { key: 'statusNm', label: '상태', form: 0.9, hide: ['td', '수정'], style: { textAlign: 'center' } },
      { key: 'userNm', label: '사용자', form: 1, style: { textAlign: 'center' } },
      { key: 'userIdText', label: '사용자아이디', form: 2, required, style: { textAlign: 'center' } },
      { key: 'grpNm', label: '그룹', form: 3, style: { textAlign: 'center' } },
      { key: 'roleNms', label: '권한', form: 4, style: { textAlign: 'center' } },
      { key: 'userNmEn', label: '사용자영문명', form: 5, required, style: { textAlign: 'center' } },
      { key: 'email', type: 'email', label: '이메일', form: 6, required, style: { textAlign: 'center' } },
      { key: 'phone', label: '연락처', form: 7, type: 'tel', style: { textAlign: 'center' } },
      { key: 'effectDt', label: '발효일', form: 8, type: 'date', style: { textAlign: 'center' }, sendMaper: v => v.replace(/-/g, '') },
      // { key: 'memberProdList', label: 'Product', form: 9, type: 'tag', style: { textAlign: 'center' } },
      // { key: '', label: '도장/서명', form: 11, style: { textAlign: 'center' } },
    ],
    custStampColumns: [   /*  회사도장 리스트 */
      { key: 'stampType', label: '종류', form: 1, renderer: (item) => `${item.stampTypeNm}`, style: { textAlign: 'center' } },
      { key: 'stampNm', label: '도장명', form: 2 },
      {
        key: 'stampFileId', label: '도장 이미지', form: 4, type: 'file', accept: ['.jpg', '.png', '.gif'], style: { textAlign: 'center' },
        renderer: (item, s) => {
          const url = s.$url(item.stampFileUrl);
          return `<img data-id="${item.stampFileId}" src="${url}" allowfullscreen style="max-height:64px; cursor:pointer" onerror="this.style.display='none'"/>`
        },
      },
    ],
    columns: [    /* 총괄관리자 추가(신규생성) spec */
      { key: 'email', label: '이메일', form: 1, required, style: { textAlign: 'center' } },
      { key: 'userNm', label: '사용자명', form: 2, required, style: { textAlign: 'center' } },
      { key: 'userNmEn', label: '사용자영문명', form: 3, style: { textAlign: 'center' } },
      { key: 'phone', label: '연락처', form: 4, style: { textAlign: 'center' } },
      { key: 'effectDt', label: '발효일', form: 5, required, type: 'date', style: { textAlign: 'center' }, sendMaper: v => v.replace(/-/g, '') },
    ],
    userSelColumns: [   /* 총괄관리자 수정 > 기존 사용자 선택 > 사용자 선택 */
      { key: 'userNm', label: '사용자', renderer: item => `${item.userNm} (${item.userIdText})`, style: { textAlign: 'center' } },
      // { key:'roleNms', label: '권한', style: { textAlign: 'center' } },
      { key: 'email', label: '이메일', style: { textAlign: 'center' } },
    ],
    custColumns: [   /* 조직 수정 모달 */
      { form: 1, key: 'custAbbr', label: 'Cust Abbr.', required, style: { textAlign: 'center' } },
      { form: 2, key: 'custName', label: '조직명', required, style: { textAlign: 'center' } },
      { form: 3, key: 'custFullName', label: '조직영문명', style: { textAlign: 'center' } },
      { form: 4, key: 'registno', label: '사업자등록번호', style: { textAlign: 'center' } },
      { form: 5, key: 'tel', label: '연락처', style: { textAlign: 'center' } },
      { form: 6, key: 'fax', label: 'FAX', style: { textAlign: 'center' } },
      { form: 7, key: 'gcifNo', label: 'GCIF', readonly: ['수정'], style: { textAlign: 'center' } },
      { form: 8, key: 'ccifNo', label: 'CCIF', readonly: ['수정'], style: { textAlign: 'center' } },
    ],
    actions: ['선택'],
  }),
  async created() {
    this.getCustInfo();
    this.getMemberList();
    this.getStampList();
  },
  mounted() { },
  beforeDestroy() { },
  computed: {},
  watch: {},
  methods: {
    async action({ action, item, form, event }) {
      if (!form && ['view'].includes(action)) {
        if (event) {
          const { target: { dataset: { u, url } } } = event;

          // 개인도장, 회사도장 조회
          if (u == 'viewMemberStamp' || u == 'viewCustStamp') {
            this.showStamp = this.$url(url);
            this.$bvModal.show('stamp') ;
            return;
          }
        }

        const unmaskKey = await this.$unmask('MEMBER_INFO');
        var member = (await this.$api('adm/cust/selectMember', { masking: false, unmaskKey, memberId: item.memberId })).data;
        this.selMember = member;

        this.keepPage = true;
        this.$set(this.memberList, this.memberList.findIndex(item => item.memberId === member.memberId), member);
        this.$nextTick(()=> { this.keepPage = false; });

        return this.$bvModal.show(action);
      }
    },
    //  회사도장 action
    async stampAction({ form, action, item, event }) {
      if (!form && ['view'].includes(action)) {
        this.selMember = item;
        if (event) {
          const { target: { tagName } } = event;
          if (tagName == 'IMG') {
            const stampUrlSpt = event.target.src.split("/");
            const stampUrl = stampUrlSpt[stampUrlSpt.length - 1];
            this.showStamp = this.$url(stampUrl);
            return this.$bvModal.show('stamp');
          }
        }
      }
    },
    // 목록 데이터 및 단건 데이터 수신
    async getCustInfo() {      
      // 조직, 총괄관리자 정보 초기화
      this.custInfo = {};
      this.managerInfo = {};

      this.cust = await this.$api('adm/cust/selectCust', { custId: this.$route.query.id });
      
      // 조직, 총괄관리자 정보 셋팅
      this.custInfo = this.cust.data.cust;
      if (this.cust.data.manager) {
        this.managerInfo = this.cust.data.manager || {};
      }
    },
    async deleteCust() {
      if (!(await this.$alert(this.$t('삭제하시겠습니까?'), { confirm: true }))) return;
      const res = await this.$api(`adm/cust/deleteCust`, { custId: this.$route.query.id });
      if (res.success) {
        await this.$alert("삭제되었습니다.");
        this.$go(-1);
      } else this.$alert(res.msg);
    },
    async editAction({ form }) {
      form.custId = this.custInfo.custId;
      form.ofacCheckYn = this.custInfo.ofacCheckYn;

      console.log('form', form);
      const res = await this.$api(`adm/cust/updateCust`, form);
      if (res.success) {
        this.getCustInfo();
        await this.$alert("수정되었습니다.");
      } else this.$alert(res.msg);
    },
    // 멤버 tab 리스트
    async getMemberList(reset) {
      if (reset != undefined) this.memberList = [];
      const {list, parameter:{total}} = await this.$api('adm/cust/selectMemberList', { custId: this.$route.query.id, searchKeyword: this.searchMemberKeyword, firstIndex: this.memberList.length + 1 });
      this.memberTotal = total;
      this.memberList.push(...list);
    },
    // 총괄관리자 기존사용자 선택 리스트
    async getManagerList(reset) {
      if (reset != undefined) this.managerList = [];
      const {list, parameter:{total}} = await this.$api('adm/cust/selectManagerAssignUserList', { custId: this.$route.query.id, searchKeyword: this.searchManagerKeyword, firstIndex: this.managerList.length + 1 });
      this.managerTotal = total;
      this.managerList.push(...list);
    },    
    // 회사도장 리스트 조회
    async getStampList() {
      const { id: custId } = this.$route.query;
      const res = await this.$api('adm/cust/selectCustStampList', { custId });
      this.stampList = this.stampList.concat(res.list);
    },
    // 총괄관리자 신규추가
    async addAdmAction({ form }) {
      const { id: custId } = this.$route.query;
      form.custId = custId;
      form.userId = this.userIdInput;
      const res = await this.$api('adm/cust/insertManager', form);
      await this.$alert(res.msg);
      if (res.success) {
        this.getCustInfo();
        this.getMemberList(true);
        this.$bvModal.hide("addAdmin")
      }
    },
    // 총괄관리자 신규추가 Show
    async showAddModal() {
      this.userIdInput = '';
      const formattedDate = new Date().toLocaleString('sv-SE', { hour12: false }).replace(',', '').slice(0, 10);
      this.$refs.adduser._data.form.effectDt = formattedDate;
    },
    // 총괄관리자 배정해제
    async unassignManager(userId) {
      if (!(await this.$alert(this.$t('총괄관리자를 배정 해제 하시겠습니까?'), { confirm: true }))) return;
      const res = await this.$api('adm/cust/unassignManager', { custId: this.$route.query.id, userId });
      await this.$alert(res.msg);
      this.getCustInfo();
      this.getMemberList(true);
    },
    // 총괄관리자 삭제
    async deleteManager(memberId) {
      const confirmBody = `
          <div>
            <div>${this.$t('총괄관리자를 영구 삭제 하시겠습니까?')}</div>
            <div class="mt-5">
              <div class="form-check form-check-sm form-check-custom form-check-solid">
                <input type="checkbox" class="form-check-input me-4" id="personalInfoDelConfirm" />
                <label for="personalInfoDelConfirm" class="text-danger">${this.$t('계정 삭제 시, 모든 데이터가 영구 삭제되는 것에 동의합니다.')}</label>
              </div>
            </div>
          </div>
        `;

      let form = { memberId: memberId };
      let confirmClose = false;
      let time = 0;
      while(!confirmClose && time++ < 5) {
        if (await this.$alert(confirmBody, { confirm: true, size: 'w-325' })) {
          form.personalInfoDelConfirm = document.getElementById('personalInfoDelConfirm').checked;
          const res = await this.$api(`adm/cust/deleteManager`, form);
          await this.$alert(res.msg);
          if(res.success) {
            confirmClose = true;
            this.getCustInfo();
            this.getMemberList(true);
          }            
        } else {
          confirmClose = true;
        }
      }
    },
    // 총괄관리자 기존사용자 선택
    async selectAdmAction({ action, item }) {
      const { id: custId } = this.$route.query;
      const userId = item.userId;
      if (['선택'].includes(action)) {
        if (this.managerInfo && this.managerInfo.memberId) {
          if (!(await this.$alert(this.$t('총괄관리자로 배정하시겠습니까?<br />(기존 총괄관리자는 일반멤버로 전환됩니다.)'), { confirm: true, title: '총괄관리자 배정' }))) return;
        } else {
          if (!(await this.$alert(this.$t('총괄관리자로 배정하시겠습니까?'), { confirm: true, title: '총괄관리자 배정' }))) return;
        }
        const res = await this.$api('adm/cust/assignManager', { custId, userId });
        await this.$alert(res.msg);
        if (res.success) {
          this.getCustInfo();          
        }
        this.$bvModal.hide('userSelect');
        this.getMemberList(true);
      }
    },
  },
}
</script>